import React from 'react';
import P from 'prop-types';
import { graphql, compose } from 'react-apollo';
import styled from 'styled-components';
import { locales } from '@becollective/constants';

import config from 'config';
import Button from 'components/Button/';
import { CREATE_OPPORTUNITY_BUTTON_QUERY } from 'gql/queries';
import { CREATE_OPPORTUNITY_MUTATION, UPDATE_OPPORTUNITY_MUTATION } from 'gql/mutations';
import ensureLoggedIn from 'utils/ensureLoggedIn';
import displayLoading from 'utils/displayLoading';
import { alertError } from 'utils/alert';
import { partnershipStatus } from 'utils/partnership';

const WrapperButton = styled(Button)`
    margin-bottom: 20px;
  `;

  const CreateOpportunityButton = ({
    data, VRCId, groupId, createOpportunityMutation, updateOpportunityMutation, referrer, clientRegion
  }) => {
  const { partnerships } = data.store.group;
  const { regionOptions } = locales;
  const regionOption = regionOptions[clientRegion];

  return (
    <WrapperButton
      color="secondary"
      onClick={() => {
        createOpportunityMutation({
          variables: {
            input: {
              groupId,
            },
          },
        })
          .then(({ data }) => {
            const { id } = data.createOpportunityV2.newOpportunity;
            const input = { id };

            const status = partnershipStatus({
              partnerships,
              requesterId: groupId,
              requesteeId: VRCId,
            });

            if (status === 'approved') {
              input.sharedPartnerGroupIds = [VRCId];
            }
            else {
              input.sharedOtherGroupIds = [VRCId];
            }

            return updateOpportunityMutation({
              variables: {
                input,
              },
            })
          })
          .then(({ data }) => {
            const { id } = data.editOpportunityV2.opportunity;
            if(regionOption && regionOption.domain){
              window.location.href = `${regionOption.domain}/opportunities/${id}/wizard?referrer=${referrer}&ignoreRegionGuess=true`;
            }else{
              window.location.href = `${config.WEB_URL}/opportunities/${id}/wizard?referrer=${referrer}&ignoreRegionGuess=true`;
            }
          })
          .catch(alertError);
      }}
    >
      + Create new opportunity
    </WrapperButton>
  );
};

CreateOpportunityButton.propTypes = {
  data: P.shape({
    store: P.shape({
      group: P.shape({
        partnerships: P.arrayOf(P.shape({})).isRequired,
      }).isRequired,
    }).isRequired,
  }).isRequired,
  VRCId: P.string.isRequired,
  groupId: P.string.isRequired,
  createOpportunityMutation: P.func.isRequired,
  updateOpportunityMutation: P.func.isRequired,
  referrer: P.string.isRequired,
};

export default compose(
  graphql(CREATE_OPPORTUNITY_BUTTON_QUERY, {
    options: ({ groupId, VRCId, }) => ({
      variables: {
        groupId,
        VRCId,
      },
      fetchPolicy: 'network-only',
    }),
  }),
  graphql(CREATE_OPPORTUNITY_MUTATION, { name: 'createOpportunityMutation' }),
  graphql(UPDATE_OPPORTUNITY_MUTATION, { name: 'updateOpportunityMutation' }),
  ensureLoggedIn,
  displayLoading(),
)(CreateOpportunityButton);
